import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "account-info__items" }

import { ref, watch } from 'vue';
import {
  BaseTable,
  BaseTextContent,
  BaseTextTitle,
  useTableColumn
} from 'xrk-components';
import { storeToRefs } from 'pinia';
import infoStore from '../../store/info';


export default /*#__PURE__*/_defineComponent({
  __name: 'account-info-book',
  setup(__props) {

const { formData } = storeToRefs(infoStore());
const tableData = ref([]);

watch(
  () => formData.value,
  val => {
    const { electronicLedgerInformation } = val;
    const _data = [
      {
        type: '入金账户',
        openBankName: electronicLedgerInformation.fyOpenBankName,
        accountNumber: electronicLedgerInformation.fyAccountNumber,
        subBranchName: electronicLedgerInformation.fySubBranchName,
        interBankNo: electronicLedgerInformation.fyInterBankNo
      },
      {
        type: '收支账户/富友ID',
        openBankName: electronicLedgerInformation.fyPaymentAccountName,
        accountNumber: electronicLedgerInformation.fyPaymentAccountNo,
        subBranchName: electronicLedgerInformation.fyPaymentAccountBranchName,
        interBankNo: ''
      },
      {
        type: '银行电子户信息',
        openBankName: electronicLedgerInformation.fyBankPortBankName,
        accountNumber: electronicLedgerInformation.fyBankPortBankNumber,
        subBranchName: '',
        interBankNo: ''
      }
    ];
    tableData.value = _data;
  },
  { once: true }
);

const columns = [
  useTableColumn({
    label: '类型',
    prop: 'type'
  }),
  useTableColumn({
    label: '开户行',
    prop: 'openBankName'
  }),
  useTableColumn({
    label: '账号',
    prop: 'accountNumber'
  }),
  useTableColumn({
    label: '支行名称',
    prop: 'subBranchName'
  }),
  useTableColumn({
    label: '联行号',
    prop: 'interBankNo'
  })
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseTextTitle), { class: "account-info__items__title" }, {
      default: _withCtx(() => [
        _createTextVNode(" 电子账簿信息 ")
      ]),
      _: 1
    }),
    _createVNode(_unref(BaseTextContent), { style: {"padding-top":"0"} }, {
      default: _withCtx(() => [
        _createVNode(_unref(BaseTable), {
          data: tableData.value,
          columns: columns
        }, null, 8, ["data"])
      ]),
      _: 1
    })
  ]))
}
}

})